const routes = [
  { 
    path: '/library/courses', 
    name: 'Courses',
    component: () => import('./courses/list.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['list_courses']
          }  
  },
  { 
    path: '/library/courses/new', 
    name: 'NewCourse',
    component: () => import('./courses/CreateCourse.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['create_courses']
          } 
  },
  { 
    path: '/library/courses/:uuid', 
    name: 'ViewCourse',
    component: () => import('./courses/Course.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['view_courses']
          }
  },
  { 
    path: '/library/courses/:uuid/edit', 
    name: 'EditCourse',
    component: () => import('./courses/EditCourse.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['update_courses']
          }
  },
  // Curricula Routes
  { 
    path: '/library/curricula', 
    name: 'Curricula',
    component: () => import('./curricula/list.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['list_courses']
          }  
  },
  { 
    path: '/library/curricula/new', 
    name: 'NewCurriculum',
    component: () => import('./curricula/CreateCurriculum.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['create_courses']
          } 
  },
  { 
    path: '/library/curricula/:uuid', 
    name: 'ViewCurriculum',
    component: () => import('./curricula/Curriculum.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['view_courses']
          }
  },
  { 
    path: '/library/curricula/:uuid/edit', 
    name: 'EditCurriculum',
    component: () => import('./curricula/EditCurriculum.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['update_courses']
          }
  },
  // End of Curricula Routes
  
  { 
    path: '/library/lessons', 
    name: 'Lessons',
    component: () => import('./lessons/list.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['list_lessons']
          } 
  },
  { 
    path: '/library/lessons/:uuid', 
    name: 'ViewLesson',
    component: () => import('./lessons/Lesson.vue'), 
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['view_lessons']
          } 
  },
  { 
    path: '/library/categories', 
    name: 'Categories',
    component: () => import('./categories/list.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['list_categories']
          } 
  },
  { 
    path: '/library/tags',
    name: 'tags', 
    component: () => import('./tags/list.vue'),
    meta: { 
            roles: ['Coordinator', 'Instructor', 'Trainee', 'Customer'], 
            permissions: ['list_tags']
          }
  },
];

export default routes;